import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => {
  const styles: StyleRules = {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    title: {
      fontSize: '1.25rem',
      marginBottom: '0.5rem',
      color: '#000',
    },

    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '19rem',

      ['@media screen and (max-width: 600px)']: {
        maxWidth: 'initial',
      },
    },
  };

  return styles;
});
